import React, { Dispatch, SetStateAction } from "react";
import { Modal } from "antd";
import AssetCardContent from "./AssetCardContent";
import { AiOutlineClose } from "react-icons/ai";

interface IExpand {
    expandedAssetProps: {
        fileName: string;
        fileExt: string;
        fileMime: string;
        fileURL: string;
        fileSrc: string;
    };
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
}

const ExpandAssetModal: React.FC<IExpand> = ({
    expandedAssetProps,
    show,
    setShow,
}) => {
    const { fileName, fileExt, fileMime, fileURL, fileSrc } =
        expandedAssetProps;
    const isExpandedView = true;
    const handleClose = () => {
        setShow(false);
    };
    return (
        <>
            <Modal
                title={
                    <div
                        className="d-flex align-items-center pb-3"
                        style={{ fontSize: "1.2rem", fontWeight: "400" }}
                    >
                        {fileName}
                    </div>
                }
                open={show}
                onCancel={handleClose}
                footer={null}
                width="70vw"
                closeIcon={<AiOutlineClose style={{ fontSize: "30px" }} />}
                centered
                styles={{
                    body: {
                        marginBottom: "16px",
                        height: "75vh",
                    },
                }}
            >
                <AssetCardContent
                    {...{
                        fileExt,
                        fileMime,
                        fileURL,
                        fileSrc,
                        isExpandedView,
                    }}
                />
            </Modal>
        </>
    );
};

export default ExpandAssetModal;
